import type { TFunction } from 'i18next';

import type { Uom } from '@/api/generated/model';
import { qtyText } from '@/lib/units';

/** «Было → стало» — пара простых значений; списки строк и партий — служебные подробности. */
export function isChange(v: unknown): v is [unknown, unknown] {
  return Array.isArray(v) && v.length === 2 && v.every((x) => x === null || typeof x !== 'object');
}

/** Значение поля для людей: пусто — «—», да/нет — словами, статус — названием, количество — в единицах. */
export function fieldValue(t: TFunction, v: unknown, field?: string, uom?: Uom | null): string {
  if (uom && field?.startsWith('qty') && typeof v === 'string') return qtyText(t, v, uom);
  if (field === 'status' && typeof v === 'string') return t(`status.shipment.${v}.label`);
  if (v === null || v === undefined || v === '') return '—';
  if (typeof v === 'boolean') return t(v ? 'audit.yes' : 'audit.no');
  return typeof v === 'string' || typeof v === 'number' ? String(v) : JSON.stringify(v);
}

/** Строки «Поле: было → стало» исправления; служебные номера (…_id) не показываем. */
export function correctionLines(
  t: TFunction,
  changes: Record<string, unknown>,
  uom?: Uom | null,
): string[] {
  return Object.entries(changes)
    .filter((kv): kv is [string, [unknown, unknown]] => isChange(kv[1]) && !kv[0].endsWith('_id'))
    .map(
      ([field, [before, after]]) =>
        `${t(`audit.field.${field}`, { defaultValue: field })}: ${fieldValue(t, before, field, uom)} → ${fieldValue(t, after, field, uom)}`,
    );
}
